import * as React from 'react';
import { ProposalStatus } from './styles';
import { Api } from '../../../typings/api';
import { Translate } from 'react-redux-i18n';
import { NewStyleColor, StyleColor } from '../../../utils/styles-constants';

interface ListItemStatusProps {
	stats: Api.ProposalData;
}

const ListItemProposalStatus = ({ stats: { status, readsNbr }}: ListItemStatusProps) => {
	let color: string;
	let message: string;
	let badge: string;
	switch (status) {
		case Api.ProposalStatus.SENT:
			color = NewStyleColor.Orange;
			message = 'messages.sent';
			badge = '';
			break;
		case Api.ProposalStatus.SEEN:
			color = NewStyleColor.VibrantGreen;
			message = 'messages.seen';
			badge = readsNbr ? ' ' + readsNbr : '';
			break;
		case Api.ProposalStatus.DRAFT:
		default:
			color = StyleColor.Grey450;
			message = 'messages.draft';
			badge = '';
	}

	return (
		<ProposalStatus color={color}>
			{'| '}<Translate value={message} />{badge}
		</ProposalStatus>
	);
};

export default ListItemProposalStatus;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/ProposalStatus/index.tsx